document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('footer-contact-form');
    if (!form) return;

    // Dodaj kontener na komunikaty błędów
    let errorBox = document.createElement('div');
    errorBox.className = 'form-error-message';
    form.parentNode.insertBefore(errorBox, form);

    form.addEventListener('submit', function (event) {
        let valid = true;
        let firstInvalid = null;
        let errorMessages = [];

        // Walidacja wymaganych pól
        form.querySelectorAll('[required]').forEach(function (input) {
            if (
                (input.type === 'checkbox' && !input.checked) ||
                (input.type !== 'checkbox' && !input.value.trim())
            ) {
                valid = false;
                input.classList.add('is-invalid');
                if (!firstInvalid) firstInvalid = input;
                errorMessages.push(
                    'Uzupełnij wymagane pole: ' +
                        (input.labels && input.labels[0]
                            ? input.labels[0].innerText
                            : input.name)
                );
            } else {
                input.classList.remove('is-invalid');
            }
        });

        // Walidacja email
        // Walidacja email
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
            if (!emailInput.value.trim()) {
                valid = false;
                emailInput.classList.add('is-invalid');
                if (!firstInvalid) firstInvalid = emailInput;
                errorMessages.push('Pole e-mail jest wymagane.');
            } else {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(emailInput.value.trim())) {
                    valid = false;
                    emailInput.classList.add('is-invalid');
                    if (!firstInvalid) firstInvalid = emailInput;
                    errorMessages.push('Podaj poprawny adres e-mail.');
                }
            }
        }

        // Walidacja numeru telefonu (PL: 9 cyfr, może być ze spacjami)
        const phoneInput = form.querySelector('input[name="phone"]');
        if (phoneInput && phoneInput.value) {
            const phonePattern = /^(\d{3} ?){3}$/;
            if (!phonePattern.test(phoneInput.value.replace(/\s/g, ''))) {
                valid = false;
                phoneInput.classList.add('is-invalid');
                if (!firstInvalid) firstInvalid = phoneInput;
                errorMessages.push('Podaj poprawny numer telefonu (9 cyfr).');
            }
        }

        // Walidacja NIP (PL: 10 cyfr, może być ze spacjami lub myślnikami)
        const nipInput = form.querySelector('input[name="NIP"]');
        if (nipInput && nipInput.value) {
            const nipPattern = /^\d{3}[- ]?\d{2}[- ]?\d{2}[- ]?\d{3}$/;
            const nipDigits = nipInput.value.replace(/[^0-9]/g, '');
            if (!nipPattern.test(nipInput.value) || nipDigits.length !== 10) {
                valid = false;
                nipInput.classList.add('is-invalid');
                if (!firstInvalid) firstInvalid = nipInput;
                errorMessages.push('Podaj poprawny NIP (10 cyfr).');
            }
        }

        // Wyświetl komunikaty błędów
        errorBox.innerHTML = '';
        if (!valid) {
            event.preventDefault();
            if (firstInvalid) firstInvalid.focus();
            errorBox.innerHTML =
                '<ul>' +
                errorMessages.map(msg => `<li>${msg}</li>`).join('') +
                '</ul>';
            return false;
        } else {
            errorBox.innerHTML = '';
        }

        // Wysyłka do Google Apps Script
        const formData = new FormData(form);
        const jsonData = {};
        formData.forEach((value, key) => {
            jsonData[key] = value;
        });

        const googleScriptURL =
            'https://script.google.com/macros/s/AKfycbzg-xrZCADXG1GuybSZKhQuI7yId2pXCqEf7nz4Fu77O7fTw4vui9UYAlf5ngeCXsiaxQ/exec';

        fetch(googleScriptURL, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(jsonData),
        })
            .then(() => {
                form.style.display = 'none';
                const successMessage = document.createElement('p');
                successMessage.textContent =
                    'Dziękujemy! Formularz został wysłany.';
                successMessage.classList.add('success-message');
                form.parentNode.appendChild(successMessage);

                setTimeout(() => {
                    form.style.display = 'block';
                    successMessage.remove();
                    form.reset();
                }, 8000);
            })
            .catch(error => {
                alert('Wystąpił błąd. Spróbuj ponownie później.');
            });

        event.preventDefault();
    });
});
